import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminTrainingFollowUpVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveTrainingFollowUp = createAsyncThunk<AdminTrainingFollowUpVM, string, { extra: Partial<Dependencies> }>(
  "trainingFollowUps/adminRetrieveTrainingFollowUp",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.adminGetOne(id);
  },
);

export const resetAdminRetrieveTrainingFollowUp = createAction("trainingFollowUps/adminResetRetrieveTrainingFollowUp");
